const FeedbackGuideForWriting = ({isRewrite = false} ) => {
  return (
    <>
      {
        isRewrite
          ? (
            <>
              &lt;영문&gt;<br />
              Read the writing carefully and then provide concise and easy-to-understand feedback to the student.
              Overall Assessment may cover topic relevancy, language use, development, idea cohesion, punctuation, pragmatics, etc.
              <br />
              &lt;국문&gt;<br />
              <u>Overall Assessment:</u><br />
              작성된 글을 확인한 후 다음을 고려하여 Overall Assessment를 남겨 주세요.<br />
              &emsp;(1) 주제와의 연관성<br />
              &emsp;(2) 문법 이해도 및 어휘 수준<br />
              &emsp;(2) 전체적인 일관성 또는 내용 구조, 문장간의 연결<br />
              &emsp;(2) 맞춤법, 구두점, 대소문자 용법 사용<br />
              등에 관해 전체적인 평가를 간결하고 알기 쉬운 표현으로 제공해주세요.
            </>
          )
          : (
            <>
              &lt;영문&gt;<br />
              Read the writing carefully and then provide concise and easy-to-understand feedback to the student.<br />
              Please revise the writing by structure (paragraph). Check if sentences are grammatically correct and/or logical. You can also suggest more appropriate sentences for each structure (paragraph).
              <br />
              &lt;국문&gt;<br />
              <u>Feedback by Structure / Paragraph:</u><br />
              작성된 글을 영역/문단별로 확인하고, 다음을 고려하여 comment를 남겨 주세요.<br />
              &emsp;(1) 문법상 틀린 부분<br />
              &emsp;(2) 논리적으로 부적절한 문장<br />
              더불어 각 영역/문단별로 수정할 문장이 있다면, 더 적절한 문장을 제시해 주십시오.
            </>
          )
      }



    </>
  );
}

export default FeedbackGuideForWriting;
